<template>
    <div style="position:relative">
        <div v-show="taskFiltered.length > 0" class="gantt"></div>
        <div v-if="taskFiltered.length == 0">No tasks found.</div>
        <Card v-if="selectedTask" id="date-popup">
            <template #content v-if="selectedTask">
                <div class="formgrid grid">
                    <label class="field col-12">{{ selectedTask.name }}</label>
                    <label class="field col-12 md:col-2" style="line-height: 30px;">Duration:</label>
                    <Calendar v-model="dates" :showIcon="true" class="field col-12  md:col-6" dateFormat="yy-mm-dd"
                        selectionMode="range" />
                    <div class="field col-12 md:col-2"></div>
                    <Button label="Close" @click="refresh(selectedTask); selectedTask = undefined"
                        class="field col-12 md:col-2" style="height: 25px;"></Button>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import Gantt from './frappe-gantt';
import { ref } from 'vue';
import DateHelper from '@/helper/DateHelper';

export default {
    name: 'GanttChart',
    props: {
        gantt: Object,
        tasks: Array,
        taskFiltered: Array,
        groups: Array,
        readonly: Boolean,
        projectStart: Date,
        projectEnd: Date
    },
    data() {
        return {
            modes: ref(["Day", "Week", "Month", 'Year']),
            selectedMode: ref("Month"),
            selectedGroups: [],
            selectedTask: undefined,
            dates: null,
            minDate: DateHelper.getDate(this.projectStart),
            maxDate: DateHelper.getDate(this.projectEnd)
        }
    },
    mounted() {
        let props = this;
        if (this.minDate) {
            if ((this.maxDate.getTime() - this.minDate.getTime()) / (1000 * 3600 * 24) < 60) {
                this.selectedMode = "Day"
            }
            else if ((this.maxDate.getTime() - this.minDate.getTime()) / (1000 * 3600 * 24) > 365) {
                this.selectedMode = "Year"
            }
        }
        let gantt = new Gantt(".gantt", this.taskFiltered, {
            header_height: 45,
            column_width: 15,
            // step: 24,
            view_modes: this.modes,
            bar_height: 21,
            bar_corner_radius: 3,
            arrow_curve: 5,
            padding: 28,
            view_mode: this.selectedMode,
            date_format: 'YYYY-MM-DD',
            draggable: !props.readonly,
            hasArrows: true,
            custom_popup_html: function (task) {
                return `
                    <div style="margin:0 5px; width:200px">
                    <h4 style="margin: 5px;color:white">${task.name}</h4>
                    <p style="padding: 0 5px;color:white"> ${task.start} to ${task.end}</p>
                    <p style="margin: 0px;font-size:10px">Drag or double click on task to edit period</p>
                    </div>
                `;
            },
            on_click: function (task) {
                props.dates = [new Date(task.start), new Date(task.end)];
                props.showPopup(task);
            },
            on_date_change: function (task, start, end) {
                console.log("on_date_change task", task)
                // let refresh = false;
                // if (start >= props.projectStart && start <= props.projectEnd) {
                //     task.start = DateHelper.getDateString(start);
                // }
                // else {
                //     task.start = DateHelper.getDateString(props.projectStart);
                //     refresh = true;
                // }
                // if (end <= props.projectEnd && end >= props.projectStart) {
                //     task.end = DateHelper.getDateString(end);
                // }
                // else {
                //     task.end = DateHelper.getDateString(props.projectEnd);
                //     refresh = true;
                // }
                task.start = DateHelper.getDateString(start);
                task.end = DateHelper.getDateString(end);
                // if (refresh) {
                //     props.gantt.refresh(props.taskFiltered);
                // }
            },
            on_progress_change: function (task, progress) {
                console.log(task, progress);
            },
            on_view_change: function (mode) {
                console.log(mode);
            }
        })
        this.$emit('setGantt', gantt);
        let taskTable = document.getElementById("targetHeight").children[0];
        let ganttChart = document.getElementsByClassName("gantt-container")[0];
        taskTable.addEventListener("scroll", (e) => {
            ganttChart.scrollTop = taskTable.scrollTop;
        });
        ganttChart.addEventListener("scroll", (e) => {
            taskTable.scrollTop = ganttChart.scrollTop;
        });
    },
    updated() {
        var new_height = document.getElementById("targetHeight").children[0].children[0].offsetHeight;
        new_height = this.readonly ? (new_height + 78) : new_height + 28;
        if (new_height > 0) {
            this.gantt.$svg.setAttribute('height', new_height);
        }
    },
    methods: {
        filterTasks() {
            let selectedGroupNames = [...new Set(this.selectedGroups.map(item => item.name))];
            this.$emit('setSelectedGroups', selectedGroupNames);
            this.$emit('filterTasks', this.selectedZone);
        },
        showPopup(task) {
            if (task == this.selectedTask) {
                this.selectedTask = undefined;
            }
            else {
                this.selectedTask = task;
                document.getElementById("date-popup").style.width = `${document.getElementsByClassName("gantt")[0].clientWidth}px`;
            }
        },
        refresh(task) {
            task.start = DateHelper.getDateString(this.dates[0]);
            task.end = this.dates[1] ? DateHelper.getDateString(this.dates[1]) : DateHelper.getDateString(this.dates[0]);
            this.gantt.refresh(this.taskFiltered);
        },
    }
}
</script>

<style scoped>
#date-popup {
    position: absolute;
    top: 0%;
}
</style>
<style>
.gantt-container {
    max-height: calc(100vh - 208px - 4rem - 268px - 80px) !important;
}

.gantt .pointer {
    display: none;
}

.gantt .tick {
    stroke: #555555
}

.gantt .date {
    position: sticky;
    top: 0;
    background: white;
    z-index: 100;
}

.view-group {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    text-align: left;
    display: flex;
    justify-content: space-between;
}

.custom_class1 .bar {
    fill: var(--epd-green) !important;
}

.custom_class2 .bar {
    fill: var(--epd-blue) !important;
}

.custom_class3 .bar {
    fill: var(--epd-yellow) !important;
}

.custom_class4 .bar {
    fill: var(--cyan-500) !important;
}

.custom_class5 .bar {
    fill: var(--pink-500) !important;
}

.custom_class6 .bar {
    fill: var(--indigo-500) !important;
}

.custom_class7 .bar {
    fill: var(--epd-green-dark) !important;
}

.custom_class8 .bar {
    fill: var(--epd-blue-dark) !important;
}

.custom_class9 .bar {
    fill: var(--epd-yellow-dark) !important;
}

.custom_class10 .bar {
    fill: var(--cyan-800) !important;
}

.custom_class11 .bar {
    fill: var(--pink-800) !important;
}

.custom_class12 .bar {
    fill: var(--indigo-800) !important;
}

.custom_class1 {
    background: var(--epd-green) !important;
    border-color: var(--epd-green) !important;
    border-radius: 3px;
    color: white;
}

.custom_class2 {
    background: var(--epd-blue) !important;
    border-color: var(--epd-blue) !important;
    border-radius: 3px;
    color: white;
}

.custom_class3 {
    background: var(--epd-yellow) !important;
    border-color: var(--epd-yellow) !important;
    border-radius: 3px;
    color: white;
}

.custom_class4 {
    background: var(--cyan-500) !important;
    border-color: var(--cyan-500) !important;
    border-radius: 3px;
    color: white;
}

.custom_class5 {
    background: var(--pink-500) !important;
    border-color: var(--pink-500) !important;
    border-radius: 3px;
    color: white;
}

.custom_class6 {
    background: var(--indigo-500) !important;
    border-color: var(--indigo-500) !important;
    border-radius: 3px;
    color: white;
}

.custom_class7 {
    background: var(--epd-green-dark) !important;
    border-color: var(--epd-green-dark) !important;
    border-radius: 3px;
    color: white;
}

.custom_class8 {
    background: var(--epd-blue-dark) !important;
    border-color: var(--epd-blue-dark) !important;
    border-radius: 3px;
    color: white;
}

.custom_class9 {
    background: var(--epd-yellow-dark) !important;
    border-color: var(--epd-yellow-dark) !important;
    border-radius: 3px;
    color: white;
}

.custom_class10 {
    background: var(--cyan-800) !important;
    border-color: var(--cyan-800) !important;
    border-radius: 3px;
    color: white;
}

.custom_class11 {
    background: var(--pink-800) !important;
    border-color: var(--pink-800) !important;
    border-radius: 3px;
    color: white;
}

.custom_class12 {
    background: var(--indigo-800) !important;
    border-color: var(--indigo-800) !important;
    border-radius: 3px;
    color: white;
}

.deselected {
    background: #ffffff !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}
</style>